<template>
  <BaseCustomizeMetal componentCode="AO" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAO",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 80px;
    left: 130px;
    @include betweenTableTablePro {
      top: 48px;
      left: 81px;
    }
    @include table {
      top: 35px;
      left: 57px;
    }
    @include phone {
      top: 26px;
      left: 41px;
    }
  }
  .templeName {
    height: 28px;
    width: 140px;
    margin-bottom: 8px;
    .textContainer {
      width: 223px;
    }
  }
  .godName {
    width: 240px;
    height: 53px;
    margin-bottom: 34px;
    .textContainer {
      width: 263px;
    }
  }
  .gift {
    margin: 0 50px auto auto;
    width: 98px;
    height: 29px;
    .textContainer {
      width: 178px;
    }
  }
  .respect {
    width: 46px;
    position: absolute;
    bottom: 6px;
    left: 48px;
    .textContainer {
      width: 46px;
    }
  }
}
</style>
